
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyButx40X7SO9hjlPcq7M5lno4T-8qps6qU",
    authDomain: "coin2cashwts.firebaseapp.com",
    projectId: "coin2cashwts",
    storageBucket: "coin2cashwts.firebasestorage.app",
    messagingSenderId: "893588680095",
    appId: "1:893588680095:web:e184b12ea946b41e81e1aa"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const messaging = typeof window !== 'undefined' ? getMessaging(app) : null;

export default app;
